import Menu from './app/shared/layout/menu/menu';
import Footer from './app/shared/layout/footer/footer';
import 'tw-animate-css';

function App() {
	return (
		<div className="flex bg-bgWhite flex-col min-h-screen">
			<Menu/>
			<Footer/>
		</div>
	);
}

export default App;
